/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
} from '@material-ui/core';

const styles = {
  header: {
    fontWeight: 600,
    paddingBottom: '10px',
  },
};

class TableVisualizer extends Component {
  sortByAttributeAndOrder(attr, sortOrder) {
    return (a, b) => {
      const valA = a[attr] || a.values[attr];
      const valB = b[attr] || b.values[attr];

      const diff = (valA > valB) ? 1 : -1;
      return diff * sortOrder;
    };
  }

  forceFloat(val) {
    if (!val) return 0;

    return parseFloat(val.toString().replace(',', '.'));
  }

  render() {
    const { data, options } = this.props;

    const mainData = data[0];

    const sortColumn = options.sortByAttribute;
    let sortOrder;
    if (sortColumn) {
      sortOrder = options.sortableAttributes[sortColumn].order === 'desc' ? -1 : 1;
      mainData.data.sort(this.sortByAttributeAndOrder(sortColumn, sortOrder));
    }

    // if (options.formats) {
    //   for (let key in options.formats) {
    //     mainData.columns.splice(+key, 1);
    //   }


    //   mainData.data = mainData.data.map((d) => {
    //     d.values = d.values.map((v, i) => {
    //       if (options.formats[i] == 'number') {
    //         return this.forceFloat(v).toFixed(2);
    //       }
    //       return v;
    //     });


    //     (options.formats.forEach((k, v) => {
    //       if (d.values[+k] === v[0]) {
    //         d.className = v[1];
    //       }

    //       d.values.splice(+k, 1);
    //     }));

    //     return d;
    //   });
    // }

    const tableHead = mainData.columns.map(c => <TableCell key={c} style={styles.header}>{c}</TableCell>);

    const tableContent = mainData.data.map((d) => {
      const cells = d.values.map((v, j) => <TableCell style={{ whiteSpace: 'pre-wrap' }} key={j}>{(v && v.replace) ? v.replace(/&lt;br&gt;/g, '\n') : v}</TableCell>);
      return <TableRow key={d.values[0]}>{cells}</TableRow>;
    });

    return (
      <Table padding="checkbox">
        <TableHead>
          <TableRow>
            {tableHead}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableContent}
        </TableBody>
      </Table>
    );
  }
}

TableVisualizer.propTypes = {
  data: PropTypes.array,
  options: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
};

TableVisualizer.defaultProps = {
  data: [],
  options: [],
};

export default TableVisualizer;
